import React, { Fragment } from 'react';

import MonitoredDocumentsListItem from './MonitoredDocumentChangeListItem.component';
import PropTypes from 'prop-types';
import ResultsList from '../../../ResultsList';

const MonitoredDocumentChangesList = ({ monitoredDocumentChanges = [], ...remain }) => {
    return (
        <Fragment>
            <ResultsList {...remain}>
                {monitoredDocumentChanges.length
                    ? monitoredDocumentChanges.map(monitoredDocumentChange => (
                          <MonitoredDocumentsListItem
                              key={monitoredDocumentChange.id}
                              {...monitoredDocumentChange}
                          />
                      ))
                    : null}
            </ResultsList>
        </Fragment>
    );
};

MonitoredDocumentChangesList.propTypes = {
    backLink: PropTypes.string,
    monitoredDocumentChanges: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
        })
    ),
};

export default MonitoredDocumentChangesList;
